import React from 'react'

export default class OldIE extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isIE10: false
    }
  }

  componentDidMount () {
    const isIE10 = /MSIE 10/.test(navigator.userAgent)
    this.setState({
      isIE10
    })
  }

  renderIE9String (siteName) {
    return `
      <!--[if lte IE 9]>
        <div class="alert-ie">
          ${siteName}.net no longer actively supports this version of Internet Explorer. We suggest that you <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">upgrade to a newer version</a> or <a href="http://browsehappy.com/">try a different browser</a>.
        </div>
      <![endif]-->
    `
  }

  renderIE10String (siteName) {
    return `
      <div class="alert-ie">
        ${siteName}.net no longer actively supports this version of Internet Explorer. We suggest that you <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">upgrade to a newer version</a> or <a href="http://browsehappy.com/">try a different browser</a>.
      </div>
    `
  }

  render () {
    const { siteName } = this.props
    const { isIE10 } = this.state
    return (
      <div>
        {isIE10 && <div dangerouslySetInnerHTML={{__html: this.renderIE10String(siteName)}} />}
        <div dangerouslySetInnerHTML={{__html: this.renderIE9String(siteName)}} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./server/template/oldIE.js